export default __webpack_public_path__ + "static/media/cableIllustration.b76c6c4c.png";